import React from 'react';
import { formatArs } from '../../utils/documentFichaMapper';

const STANDARD_VAT_RATES = [0.21, 0.105];

function vatLabel(rate) {
  if (Math.abs(rate - 0.21) < 0.001) return 'IVA 21%';
  if (Math.abs(rate - 0.105) < 0.001) return 'IVA 10,5%';
  return `IVA ${(rate * 100).toFixed(1).replace('.0', '')}%`;
}

export default function AmountsTable({ amounts, highlightKey, onHighlight }) {
  if (!amounts) return null;
  const {
    currency,
    net_taxed,
    net_untaxed,
    vat,
    perceptions,
    other_taxes,
    total,
    exchange_rate,
  } = amounts;

  const hl = (key) => highlightKey === key;
  const vatRows = STANDARD_VAT_RATES.map((rate) => {
    const found = (vat || []).find((row) => Math.abs(row.rate - rate) < 0.001);
    return { rate, amount: found?.amount ?? 0, hasValue: Boolean(found) };
  });

  return (
    <section className="dv-section">
      <h3 className="dv-section-title">🧮 Importes</h3>
      <div className="dv-section-body">
        <div
          className={`dv-amt${hl('amounts.net_taxed') ? ' dv-amt--hl' : ''}`}
          onClick={() => onHighlight?.('amounts.net_taxed')}
          role="presentation"
        >
          <span className="dv-amt-k">Neto gravado</span>
          <span className="dv-amt-v num">{formatArs(net_taxed)}</span>
        </div>
        <div className="dv-amt">
          <span className="dv-amt-k">Neto no gravado</span>
          <span className="dv-amt-v num">{formatArs(net_untaxed)}</span>
        </div>
        {vatRows.map((row) => (
          <div key={row.rate} className="dv-amt">
            <span className="dv-amt-k">{vatLabel(row.rate)}</span>
            <span className="dv-amt-v num">
              {row.hasValue ? formatArs(row.amount) : '—'}
            </span>
          </div>
        ))}
        {(perceptions || []).map((p, i) => (
          <div key={i} className="dv-amt">
            <span className="dv-amt-k">Percepciones {p.label}</span>
            <span className="dv-amt-v num">{formatArs(p.amount)}</span>
          </div>
        ))}
        {other_taxes > 0 && (
          <div className="dv-amt">
            <span className="dv-amt-k">Otros tributos</span>
            <span className="dv-amt-v num">{formatArs(other_taxes)}</span>
          </div>
        )}
        <div
          className={`dv-amt dv-amt--total${hl('amounts.total') ? ' dv-amt--hl' : ''}`}
          onClick={() => onHighlight?.('amounts.total')}
          role="presentation"
        >
          <span className="dv-amt-k">Total</span>
          <span className="dv-amt-v num">
            {formatArs(total)} {currency || 'ARS'}
          </span>
        </div>
        {currency === 'USD' && exchange_rate && (
          <div className="dv-amt-fx num">
            Tipo de cambio {exchange_rate.toLocaleString('es-AR')} → ARS{' '}
            {formatArs(total * exchange_rate)}
          </div>
        )}
      </div>
    </section>
  );
}
